<template>
    <FilterBody
        v-model:search-model-value="organizationFilterProperties.searchTerm"
        :label="t('projectclient.projectlist.table.organization.header')"
        :display-search="true"
        :search-placeholder="t('projectclient.projectlist.topbar.filters.organization.search.placeholder')"
        :items="organizationFilterProperties.displayedResults"
        :selected-items="screenSizeSearchParams.organizations"
        :pending="organizationFilterProperties.pending"
        :display-show-more="organizationFilterProperties.hasMoreToShow && !organizationFilterProperties.isSearchActive"
        @reset="projectListFiltersStore.handleResetCategory('organizations')"
        @check:item="handleCheckBoxChange"
        @show-more="handleShowMore"
    >
        <template #item="{item}">{{ item.label }} {{ `${item.count > 0 ? ` (${item.count})` : ''}` }}</template>
    </FilterBody>
</template>

<script lang="ts" setup>
    import {computed} from 'vue';
    import type {TypedAggregationResource} from '@common/composables';
    import {useScreenSizeStore} from '@common/stores';
    import {useProjectsListStore, useProjectsListFiltersStore} from '@features/projects-list/stores';
    import {storeToRefs} from 'pinia';
    import {useTranslation} from '#imports';
    import FilterBody from '../wrappers/FilterBody.vue';

    const {t} = useTranslation();

    const screenSizeStore = useScreenSizeStore();
    const {isSmallScreen} = storeToRefs(screenSizeStore);

    const projectListStore = useProjectsListStore();
    const {searchParams} = storeToRefs(projectListStore);

    const projectListFiltersStore = useProjectsListFiltersStore();
    const {temporarySearchParams, organizationFilterProperties} = storeToRefs(projectListFiltersStore);

    const screenSizeSearchParams = computed(() => {
        if (isSmallScreen.value) {
            return temporarySearchParams.value;
        } else {
            return searchParams.value;
        }
    });

    function handleCheckBoxChange(item: TypedAggregationResource<string>) {
        projectListFiltersStore.handleUpdateCategory('organizations', item.value);
    }

    function handleShowMore() {
        organizationFilterProperties.value.resultsSize += 6;
    }
</script>
